module.exports = {
    apiUrl: 'https://api-staging.nssolution.net/api/',
    storageUrl: 'https://api-staging.nssolution.net/public',
    envType: 'staging',
    whatsappNo: +919173722173
}